import { Button } from '@components'
import { FeatureWrapper } from '@context'
import {
  SlideContent,
  SlideFooter,
  SlideTitle,
  Spacer
} from '@pages/BankIntegrationOnboardingPage/slides/slide.styled'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaArrowRight } from 'react-icons/fa'
import styled from 'styled-components'
import { HolviPromoCard } from '@root/containers/HolviPromoCard'

interface Props {
  onDone: () => void
  goBack: () => void
}

export const PartnerSlide: React.FC<Props> = ({ onDone, goBack }) => {
  const { t } = useTranslation()

  return (
    <>
      <SlideContent>
        <SlideTitle>{t('bankOnboarding.partnerSlide.title')}</SlideTitle>

        <Partners>
          <FeatureWrapper feature="holvi_business_accounts">
            <HolviPromoCard />
          </FeatureWrapper>
        </Partners>
      </SlideContent>
      <SlideFooter>
        <Button type="button" onClick={() => goBack()}>
          {t('general.back')}
        </Button>
        <Spacer />
        <Button
          type="button"
          onClick={() => onDone()}
          iconRight={<FaArrowRight />}
          intent="default"
          data-test="onboarding-partner-skip-button"
        >
          {t('general.skip')}
        </Button>
      </SlideFooter>
    </>
  )
}

const Partners = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.md}rem;
  gap: ${({ theme }) => theme.spacing.md}rem;
  margin-top: 2rem;
`
